module.exports = __webpack_public_path__ + "img/front_buttons_quantity.2ecbf026.png";